import { signal } from 'services/SignalsService'

function init() {
  document.addEventListener('visibilitychange', function () {
    signal.dispatch('VISIBILITY', document.visibilityState === 'visible')
  })
}

export const VisibilityService = { init }
